import { tickerItems } from "@/mocks/trending";

export default function TickerBar() {
  const items = [...tickerItems, ...tickerItems];

  return (
    <div className="border-y border-primary-600/30 bg-primary-500 text-background-50">
      <div className="flex h-11 items-center gap-3 overflow-hidden px-4 md:px-6">
        <span className="inline-flex flex-shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/15 px-3 py-1 text-[11px] font-label font-bold">
          <i className="ri-flashlight-fill" aria-hidden="true" />
          独家首发
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track">
            {items.map((text, index) => (
              <span key={`${text}-${index}`} className="flex-shrink-0 whitespace-nowrap px-5 text-xs md:text-sm">
                {text}
                <span className="ml-5 text-background-50/40" aria-hidden="true">
                  ◆
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}